import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { VideoAutoplay } from '../video-autoplay/video-autoplay';

@Component({
  selector: 'fr8bot-web-about-section',
  templateUrl: './web-about-section.html',
  styleUrl: './web-about-section.scss',
  imports: [VideoAutoplay],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebAboutSection {
  videoSrc = input('');
  posterSrc = input('');
  shipNow = output();
}
